import {
  fallbackPlacementChannelMeta,
  placementChannelMeta,
  type PlacementChannelMeta,
} from "@/app-config";
import type {
  AdPlacementRecord,
  AdPlacementsByChannel,
} from "@/services/ad-placements.service";

export type PlacementChannelOption = {
  id: AdPlacementRecord["channel"];
  title: PlacementChannelMeta["title"];
  impressionsLabel: PlacementChannelMeta["impressionsLabel"];
  zonesLabel: PlacementChannelMeta["zonesLabel"];
  icon: PlacementChannelMeta["icon"];
  accent: PlacementChannelMeta["accent"];
  zones: Array<{
    id: AdPlacementRecord["zoneId"];
    title: string;
    description: AdPlacementRecord["description"];
    impressionsLabel: string;
  }>;
};

export function getPlacementChannelLabel(channel: string): string {
  return (placementChannelMeta[channel] ?? fallbackPlacementChannelMeta).title;
}

export function toPlacementChannelOption(
  channel: AdPlacementRecord["channel"],
  adPlacements: AdPlacementRecord[],
): PlacementChannelOption {
  const meta = placementChannelMeta[channel] ?? fallbackPlacementChannelMeta;

  return {
    id: channel,
    title: meta.title,
    impressionsLabel: meta.impressionsLabel,
    zonesLabel: meta.zonesLabel,
    icon: meta.icon,
    accent: meta.accent,
    zones: adPlacements.map((adPlacement) => ({
      id: adPlacement.zoneId,
      title: adPlacement.title ?? adPlacement.zoneId,
      description: adPlacement.description,
      impressionsLabel: adPlacement.description ?? "",
    })),
  };
}

export function getPlacementChannelOptions(
  placementsByChannel: AdPlacementsByChannel,
): PlacementChannelOption[] {
  return Object.entries(placementsByChannel).map(
    ([channel, channelPlacements]) =>
      toPlacementChannelOption(channel, channelPlacements),
  );
}

export function getPlacementChannelZones(
  channels: PlacementChannelOption[],
): Record<string, string[]> {
  return Object.fromEntries(
    channels.map((channel) => [
      channel.id,
      channel.zones.map((zone) => zone.id),
    ]),
  );
}
